module.exports = __webpack_public_path__ + "img/background-top.c64cdf6e.jpg";